/**
 * Unified query keys for the context selector
 */
export const contextSelectorQueryKeys = {
  all: ["contextOptions"] as const,
  list: (filters: string) =>
    [...contextSelectorQueryKeys.all, { filters }] as const
};
